import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['star', 'input']

  connect() {
    this.updateStars(parseInt(this.inputTarget.value) || 0)
  }

  select(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.inputTarget.value = rating
    this.updateStars(rating)
  }

  hover(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.updateStars(rating, true)
  }

  reset() {
    this.updateStars(parseInt(this.inputTarget.value) || 0)
  }

  updateStars(rating, isHover = false) {
    this.starTargets.forEach((star, index) => {
      const starRating = index + 1
      const svg = star.querySelector('svg')

      if (starRating <= rating) {
        svg.classList.remove('text-gray-300')
        svg.classList.add('text-yellow-400')
      } else {
        svg.classList.remove('text-yellow-400')
        svg.classList.add('text-gray-300')
      }
    })
  }
}
